import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../constants';
import FieldWrapper from '../../ui/field-wrapper';
import { TextField } from '../../ui/text-field';
const EcomCompanyName = props => {
  const fieldType = FIELD_TYPES.ECOM_COMPANY_NAME;
  return /*#__PURE__*/React.createElement(FieldWrapper, {
    fieldType: fieldType,
    dataHook: props.target
  }, /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    fieldType: fieldType
  })));
};
export default EcomCompanyName;
//# sourceMappingURL=ecom-company-name.js.map